import React, {useState} from 'react'
import _ from 'lodash'
import EditFontDetails from "../settings/edit-font-details";
import {
    DEFAULT_RECTANGLE,
    DEFAULT_TEXT_TAB,
    DESIGN_KEY_PREFIX,
    FLIP_DIRECTION_KEY, RECTANGLE_FIELD_LIST, SHAPES_LIST, TEXT_PATH_FIELD_LIST,
} from "../../../constants/design.constant";
import EditColorDetails from "../settings/edit-color-details";
import EditStrokeDetails from "../settings/edit-stroke-details";
import EditShadowDetails from "../settings/edit-shadow-details";
import {processColorDetails} from "../../../../common/utils/color-util";
import EditFlipDetails from "../settings/edit-flip-details";
import EditRotationDetails from "../settings/edit-rotation-details";
import {getNextItemKey} from "../../../../common/utils/item-key-util";
import {DocumentDuplicateIcon} from "@heroicons/react/24/solid";
import EditTextPathDetails from "../settings/edit-text-path-details";
import {processTextPathData} from "../../../utils/svg-data.util";
import RenderFields from "../../../../common/ui/render-fields";
import DeleteDesignVariantImage from "../layers/delete-design-variant-image";
import DeleteShape from "./delete-shape";

const Shapes = ({designVariantDetail, setDesignVariantDetail}) => {

    const handleAddNewShape = (shapeDetail) => {
        const existingDesignVariantDetail = {...designVariantDetail};
        existingDesignVariantDetail.shapes = existingDesignVariantDetail.shapes || [];

        const newShape: any = DEFAULT_RECTANGLE;
        _.forEach(shapeDetail.fields, field => {
            newShape[field.attribute] = field.default;
        });

        newShape.key = getNextItemKey(existingDesignVariantDetail.shapes, DESIGN_KEY_PREFIX.SHAPE);

        existingDesignVariantDetail.shapes.push(newShape);
        setDesignVariantDetail(existingDesignVariantDetail);
        console.log({existingDesignVariantDetail})
    }

    return (
        <>

            <div className="border border-gray-400 bg-white">
                <div
                    className="text-center font-bold p-2 border border-gray-400 bg-gray-400 text-white sticky top-0">Shapes
                </div>

                <div
                    className="flex flex-wrap justify-center content-start my-2">
                    {SHAPES_LIST?.map((shapeDetail, index) => {
                        return <React.Fragment key={`shape-${index}`}>
                            <div
                                className={`m-1 p-1 w-32 rounded cursor-pointer content-between grid grid-cols-1 bg-green-300 text-green-900`}>

                                <div onClick={() => handleAddNewShape(shapeDetail)}
                                     className="text-center py-4 rounded">
                                    {shapeDetail?.label}
                                </div>

                            </div>
                        </React.Fragment>
                    })}
                </div>
            </div>

        </>
    )
}

export default Shapes
